var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job-search-top bg-white p-3 rounded-bottom" },
    [
      _c(
        "div",
        { staticClass: "inputs-wrapper rounded" },
        [
          _c("b-row", { staticClass: "row no-gutters mb-2" }, [
            _c(
              "div",
              { staticClass: "input-item align-items-center d-flex px-1" },
              [
                _c(
                  "div",
                  { staticClass: "d-none d-md-block" },
                  [
                    _vm.isMobile === false
                      ? _c("b-icon", {
                          staticClass: "mx-2",
                          attrs: {
                            icon: "briefcase-fill",
                            variant: "brand-dark",
                            "font-scale": "1.2",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "badges-container d-flex flex-grow-1 w-100 p-1 pl-0 align-items-center",
                  },
                  [
                    _vm._l(
                      _vm.getFilterStrings.slice(
                        0,
                        _vm.showAllSearchStrings === false
                          ? 1
                          : _vm.getFilterStrings.length
                      ),
                      function (item, index) {
                        return _c(
                          "b-badge",
                          { key: index, staticClass: "m-1" },
                          [
                            _c(
                              "div",
                              { staticClass: "badge-text ml-1 cursor-default" },
                              [_vm._v(_vm._s(item))]
                            ),
                            _c("b-icon", {
                              staticClass: "ml-1 clickable",
                              attrs: { icon: "x", "font-scale": "1.5" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeKeyword(item)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    _vm.isMobile && _vm.getFilterStrings.length > 1
                      ? _c(
                          "span",
                          {
                            staticClass: "text-brand-light clickable",
                            on: {
                              click: function ($event) {
                                return _vm.showAll()
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.showAllSearchStrings == true ? "-" : "+"
                                ) +
                                _vm._s(_vm.getFilterStrings.length - 1)
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.startSearch()
                          },
                        },
                      },
                      [
                        _c("b-input", {
                          staticClass: "w-100",
                          attrs: {
                            type: "text",
                            autocomplete: "off",
                            placeholder:
                              _vm.isMobile === false
                                ? _vm.t.jobSearch_V2_Jobkeywords_Placeholder
                                : _vm.isMobile &&
                                  _vm.getFilterStrings.length < 1
                                ? _vm.t.jobSearch_V2_Jobkeywords_Placeholder
                                : "",
                          },
                          on: {
                            focus: function ($event) {
                              return _vm.openKeywordsTypeahead(true)
                            },
                          },
                          model: {
                            value: _vm.currentInput,
                            callback: function ($$v) {
                              _vm.currentInput = $$v
                            },
                            expression: "currentInput",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.currentInput.length > 1
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "clickable text-brand-medium fit-content mr-2",
                            on: {
                              click: function ($event) {
                                return _vm.addKeyword()
                              },
                            },
                          },
                          [_vm._v("+ " + _vm._s(_vm.t.general_Add))]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ]),
          _c("LocationComponentsContainer", {
            attrs: {
              userInfo: _vm.userInfo,
              useAllCountries: true,
              useIcon: true,
              canSearchFromMap: false,
              settings: _vm.settings,
              countriesToExclude: "FI",
            },
            on: {
              startSearch: function ($event) {
                return _vm.startSearch()
              },
              inputChanged: function ($event) {
                return _vm.inputChanged($event)
              },
              openKeywordsTypeahead: function ($event) {
                return _vm.openKeywordsTypeahead($event)
              },
              changeShowOverlay: function ($event) {
                return _vm.changeShowOverlay($event)
              },
            },
          }),
        ],
        1
      ),
      _vm.filterIsActive
        ? _c("JobSearchFilters", {
            attrs: {
              filterIsActive: _vm.filterIsActive,
              showRadioButtons: true,
              filtersToExclude: [],
            },
            on: {
              startSearch: _vm.startSearch,
              changeShowOverlay: function ($event) {
                return _vm.changeShowOverlay($event)
              },
              changeMobileFiltersIsOpen: function ($event) {
                return _vm.changeMobileFiltersIsOpen($event)
              },
            },
          })
        : _vm._e(),
      _vm.isMobile
        ? _c(
            "div",
            {
              staticClass:
                "w-10 px-0 px-sm-4 py-2 py-sm-4 d-flex justify-content-end",
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn-outline-primary",
                  on: {
                    click: function ($event) {
                      return _vm.changeFilterIsActive()
                    },
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-3",
                    attrs: {
                      icon: _vm.filterIsActive ? "x" : "sliders",
                      scale: "1.2",
                    },
                  }),
                  _vm._v(_vm._s(_vm.t.jobSearch_V2_Settings)),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("JobSearchButtons", {
        attrs: {
          filterIsActive: _vm.filterIsActive,
          currentInput: _vm.currentInput,
          locationInput: _vm.locationInput,
          canSaveSearch: _vm.canSaveSearch,
          mobileFiltersIsOpen: _vm.mobileFiltersIsOpen,
          selectedJobPosting: _vm.selectedJobPosting,
        },
        on: {
          changeFilterIsActive: function ($event) {
            return _vm.changeFilterIsActive()
          },
          clearSearch: function ($event) {
            return _vm.clearSearch()
          },
          openSaveSearchModal: function ($event) {
            return _vm.openSaveSearchModal()
          },
          goToPage: function ($event) {
            return _vm.goToPage($event)
          },
          startSearch: _vm.startSearch,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }